<template>
    <div class="p-12 bg-gray-100 border border-gray-300" @dragover.prevent="dragover" @drop.prevent="drop">
        <input type="file" id="assetsFieldHandle" class="absolute w-px h-px overflow-hidden opacity-0" @input="drop" ref="file" :accept="accept" />
    
        <label for="assetsFieldHandle" class="block cursor-pointer">
            <div v-if="isFile">Archivo seleccionado: {{fileName}}</div>
            <div v-if="!isFile">
                <span class="underline">click aqui</span> para subir un archivo
            </div>
        </label>
    </div>
</template>

<script>
import { ref } from 'vue'
export default {
    props: ['accept'],
    setup(props,{emit}){
        const file = ref()
        const isFile = ref(false)
        const fileName = ref('')
        console.log(file.value)
        const dragover = (event)=>{
            console.log(event)
        }

        const drop = (event)=>{
            file.value = event.target.files[0]
            emit('update:modelValue',file.value)
            isFile.value = true;
            fileName.value = file.value.name
        }

        return{
            file,
            isFile,
            fileName,
            dragover,
            drop
        }
    }
}
</script>

<style>

</style>